export default __webpack_public_path__ + "static/media/CCTV.6f9baaa5.png";